document.addEventListener("DOMContentLoaded", function() {
    const countdownElements = document.querySelectorAll('[data-countdown]');
    
    countdownElements.forEach(function(element) {
        // Get the target date from data attribute
        const countdownDate = new Date(element.dataset.countdown).getTime();
        const countdownDisplay = element.querySelector('.global-alert__countdown-timer');
        
        if (!countdownDisplay) return;
        
        // Update the countdown every second
        const countdownTimer = setInterval(function() {
            // Get current date and time
            const now = new Date().getTime();
            
            // Calculate the time remaining
            const timeRemaining = countdownDate - now;
            
            // Calculate days, hours, minutes, and seconds
            const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
            
            // Format with leading zeros
            const daysFormatted = days.toString().padStart(2, '0');
            const hoursFormatted = hours.toString().padStart(2, '0');
            const minutesFormatted = minutes.toString().padStart(2, '0');
            const secondsFormatted = seconds.toString().padStart(2, '0');
            
            // Update the countdown display
            countdownDisplay.querySelector('.days').textContent = daysFormatted;
            countdownDisplay.querySelector('.hours').textContent = hoursFormatted;
            countdownDisplay.querySelector('.minutes').textContent = minutesFormatted;
            countdownDisplay.querySelector('.seconds').textContent = secondsFormatted;
            
            // If countdown is finished
            if (timeRemaining < 0) {
                clearInterval(countdownTimer);
                countdownDisplay.innerHTML = "Event has ended";
            }
        }, 1000);
    });
});
